// Generated from SVG to Code Figma Plugin
'use client';
import React from 'react';
import { chakra } from '@chakra-ui/react';

type Props = {
  width?: number;
  fill?: string;
};
export const Tip = ({ fill = 'none', width = 14 }: Props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_23315_12532)">
      <path
        d="M8.57512 2.00005L14.9258 13.0001C14.9843 13.1014 15.0151 13.2164 15.0151 13.3334C15.0151 13.4504 14.9843 13.5654 14.9258 13.6667C14.8673 13.7681 14.7831 13.8522 14.6818 13.9107C14.5804 13.9692 14.4655 14 14.3484 14.0001H1.64712C1.5301 14 1.41513 13.9692 1.31379 13.9107C1.21245 13.8522 1.12829 13.7681 1.06978 13.6667C1.01127 13.5654 0.980468 13.4504 0.980469 13.3334C0.980469 13.2164 1.01127 13.1014 1.06979 13.0001L7.42045 2.00005C7.47896 1.89871 7.56312 1.81456 7.66447 1.75606C7.76581 1.69755 7.88077 1.66675 7.99778 1.66675C8.1148 1.66675 8.22976 1.69755 8.3311 1.75606C8.43245 1.81456 8.5166 1.89871 8.57512 2.00005ZM7.33112 10.6667V12.0001H8.66445V10.6667H7.33112ZM7.33112 6.00005V9.33338H8.66445V6.00005H7.33112Z"
        fill={fill}
      />
    </g>
    <defs>
      <clipPath id="clip0_23315_12532">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
